
import { IDotDanhGiaSelectRequest } from "../../../models/request/danh-gia/IDotDanhGiaSelectRequest";
import { IDotDanhGia } from "../../../models/response/danh-gia/IDotDanhGia";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotDanhGiaActionTypeDefine = {
    CHANGE_FILTER: {} as IDotDanhGiaSelectRequest,
    LOAD_START: {} as IDotDanhGiaSelectRequest,
    LOAD_SUCCESS: {} as IDotDanhGia[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | IDotDanhGia,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IDotDanhGia,
    SAVE_SUCCESS: {} as IDotDanhGia,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eDotDanhGiaActionTypeIds = generateActionTypeIds(eDotDanhGiaActionTypeDefine, "DOT_DANH_GIA")

export type IDotDanhGiaActions = IGenericActionType<typeof eDotDanhGiaActionTypeDefine, "DOT_DANH_GIA">